/** localStorage: force compact TV layout when auto-detection misses (e.g. some Fire/Silk WebViews). */
export const ZFLIX_FORCE_TV_UI_KEY = 'zflixForceTvUi';

export function readZflixForceTvUi() {
  try {
    return typeof window !== 'undefined' && window.localStorage?.getItem(ZFLIX_FORCE_TV_UI_KEY) === '1';
  } catch {
    return false;
  }
}

export function setZflixForceTvUi(on) {
  try {
    if (on) window.localStorage.setItem(ZFLIX_FORCE_TV_UI_KEY, '1');
    else window.localStorage.removeItem(ZFLIX_FORCE_TV_UI_KEY);
  } catch (_) {}
}

export function applyZflixDesktopBrowserDensity() {
  const html = document.documentElement;
  try {
    const ua = navigator.userAgent || '';
    const inAndroidWebView =
      /; wv\)/i.test(ua) ||
      window.__zflixAndroidWebView === true ||
      (/\bAndroid\b/i.test(ua) && /\b(?:wv|WebView)\b/i.test(ua));
    html.classList.toggle('zflix-android-webview', inAndroidWebView);

    const uaTvLeanback =
      window.__zflixTvClient === true ||
      /\bAndroid TV\b/i.test(ua) ||
      /\bAFT[A-Z]{2,}\b/i.test(ua) ||
      /\b(?:BRAVIA|Smart-TV|TV\s*BOX)\b/i.test(ua) ||
      (/\bAndroid\b/i.test(ua) && /\bTV\b/i.test(ua) && !/\bMobile\b/i.test(ua));

    const coarsePointer = window.matchMedia?.('(pointer: coarse)')?.matches === true;
    const wide = window.innerWidth >= 960;
    const iw = window.innerWidth;
    const forceTvUi = readZflixForceTvUi();

    /** Fire TV / Silk / Amazon shells often omit `; wv)` — still need compact chrome + non-scrolling rail */
    const amazonOrSilkTvShell =
      /\b(?:AFT[A-Z0-9]{2,}|KF(?:OT|TR|ON|TW)WI)\b/i.test(ua) ||
      /\bCloudTV\b/i.test(ua) ||
      /\b(?:AmazonWebAppPlatform|com\.amazon\.cloud9)\b/i.test(ua) ||
      /\bSilk\b/i.test(ua);

    const tvExtraDense =
      forceTvUi ||
      (inAndroidWebView && iw >= 480) ||
      (uaTvLeanback && iw >= 480) ||
      (amazonOrSilkTvShell && iw >= 360) ||
      (coarsePointer && iw >= 900 && inAndroidWebView && !/\bMobile\b/i.test(ua));

    const desktopMouseCompact = wide && !coarsePointer && !inAndroidWebView && !uaTvLeanback && !forceTvUi;
    const useCompact = desktopMouseCompact || tvExtraDense;

    html.classList.toggle('zflix-desktop-browser-density', useCompact);
    html.classList.toggle('zflix-tv-apk-density', tvExtraDense);
  } catch {
    html.classList.remove('zflix-desktop-browser-density', 'zflix-tv-apk-density', 'zflix-android-webview');
  }
}
